// eslint-disable-next-line import/prefer-default-export
export const muiMobileStepperComponent = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: 'transparent',
      display: 'flex',
      padding: theme.spacing('NONE'),
      width: '100%',
    }),
    dot: ({ theme }) => ({
      backgroundColor: 'transparent',
      border: `2px solid ${theme.palette.main.professional_blue}`,
      width: theme.spacing('MEDIUM'),
      height: theme.spacing('MEDIUM'),
    }),
    dotActive: ({ theme }) => ({
      backgroundColor: theme.palette.main.professional_blue,
    }),
  },
};
